import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import InitialContext from 'state/static-data/InitialContext';
import { ApplicationState } from 'state/store/configureStore';
import { VariationsState, VisitType } from 'state/types';

const FEATURE_NAME = "twister-variations";

const initialState: VariationsState = InitialContext.getVariationsStates() || {
  variations: []
};

const slice = createSlice({
  name: FEATURE_NAME,
  initialState: initialState,
  reducers: {
  },
});

export const selectVariationsState = (state: ApplicationState): VariationsState => state.variationsState;

export default slice.reducer;
